import { useEffect, useState } from 'react'
import PageHeader from '../../Components/PageHeader/PageHeader'
import { ApiHit } from '../../Api/ApiHit'
import { deleteBook, searchBook } from '../../Constant/Constant'
import { useDispatch, useSelector } from 'react-redux'
import { setAccountList } from '../../Redux/Actions/AccountAction'
import { setPagination } from '../../Redux/Actions/TableAction'
import AppTable from '../../Components/AppTable/AppTable'
import { setApiJson } from '../../Redux/Actions/ApiAction'
import AddBooks from './AddBooks'
import ActionButton from '../../Components/AppButton/ActionButton'
import DeleteActionButton from '../../Components/AppButton/DeleteActionButton'
import { PencilIcon } from 'lucide-react'
import CustomModal from '../../Components/CustomModal/CustumModal'
import toast from 'react-hot-toast'
import { getCahbookUser, setCashbookUser, getSelectedAccount, getSelectedBook, setSelectedBook } from '../../Storage/Storage'

function BookManagement() {
  const dispatch = useDispatch()
  const TableReducer = useSelector((state) => state.TableReducer)
  const AccountReducer = useSelector((state) => state.AccountReducer)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [selectedBook, setSelectedBook] = useState(null)

  const handleModalClose = () => {
    dispatch(setApiJson({}))
    setSelectedBook(null)
    setIsEditModalOpen(false)
    getAccounts()
  }

  const handleEdit = (book) => {
    setSelectedBook(book)
    dispatch(setApiJson(book))
    setIsEditModalOpen(true)
  }

  const handleDelete = (book) => {
    ApiHit({_id: book?._id}, deleteBook).then((res) => {
      if (res?.statusCode === 200) {
        const currentUser = getCahbookUser();
        if (currentUser) {
          currentUser.bookId = (currentUser.bookId || []).filter(b => b._id !== book._id);
          setCashbookUser(currentUser);
        }
        if (getSelectedBook()?._id === book._id) {
          setSelectedBook(null);
        }
        toast.success(res?.message || 'Book deleted successfully')
        window.location.reload();
      }
      else {
        toast.error(res?.error || 'Failed to delete book')
      }
    }).catch((error) => {
      console.error("Error deleting book:", error)
      toast.error('Failed to delete book')
    })
  }

  useEffect(() => {
    getAccounts()
  }, [TableReducer.pagination.page, TableReducer.pagination.limit])

  const getAccounts = () => {
    const json = {
      page: TableReducer.pagination.page,
      limit: TableReducer.pagination.limit,
      search: {
        accountId : getSelectedAccount()?._id
      }
    }
    ApiHit(json, searchBook).then((res) => {
      if (res?.statusCode === 200) {
        dispatch(setAccountList(res?.data?.docs))
        const paginationData = {
          total: res?.data?.totalDocs || 0,
          page: TableReducer.pagination.page,
          limit: TableReducer.pagination.limit,
        }
        dispatch(setPagination(paginationData))
      }
    })
  }

  const baseIndex = (TableReducer.pagination.page - 1) * TableReducer.pagination.limit

  const tableHeaders = [
    {
      title: "S.No",
      key: "serialNumber",
      width: "60px",
      align: "center",
      priority: 1,
      render: (_, _row, index) => {
        const serialNumber = baseIndex + index + 1
        return (
          <div className="text-center">
            <span className="text-sm font-medium text-gray-900">{serialNumber}</span>
          </div>
        )
      }
    },
    {
      title: "Book Name",
      key: "bookName",
      priority: 1,
      render: (value) => (
        <div className="text-sm text-gray-900">
          {value || 'N/A'}
        </div>
      )
    },
    {
      title: "Status",
      key: "status",
      priority: 1,
      align: "center",
      render: (value) => (
        <div className="flex justify-end md:justify-center">
          <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
            value ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
          }`}>
            {value ? 'Active' : 'Inactive'}
          </span>
        </div>
      )
    },
    {
      title: "Created At",
      key: "createdAt",
      priority: 2,
      render: (value) => (
        <div className="text-sm text-gray-900">
          {value ? new Date(value).toLocaleDateString() : 'N/A'}
        </div>
      )
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_value, row) => {
        return (
          <div className="flex justify-end md:justify-center space-x-2">
            <ActionButton
              onClick={() => handleEdit(row)}
              tooltip="Edit Book"
              icon={<PencilIcon className='w-4 h-4' />}
            />

            <DeleteActionButton
              onConfirm={() => handleDelete(row)}
              itemName="book"
              tooltip="Delete Book"
            />
          </div>
        )
      }
    }
  ]

  return (
    <div>
      <PageHeader
        title={'Business Book'}
        description={'Create and manage business book and related details'}
      />
        <div className="mt-5">
        <AppTable
          TH={tableHeaders}
          TD={AccountReducer.accountList || []}
          emptyMessage="No books found"
          hidePagination={false}
          buttonText={"Add Book"}
          modalComap={(onClose) => <AddBooks onClose={onClose} />}
          modalSize={"sm"}
          onModalClose={handleModalClose}
        />
      </div>

      <CustomModal
        isOpen={isEditModalOpen}
        onClose={handleModalClose}
        size="sm"
      >
        <AddBooks
          isEditMode={true}
          bookData={selectedBook}
          onClose={handleModalClose}
        />
      </CustomModal>
    </div>
  )
}

export default BookManagement
